export function faqsPageSectionLeads(sitePages) {
    // Add missing faqs page leads
    const faqsLeads = {
        "Excluding Yourself from the Settlement": `If you don’t want a payment from this Settlement, and you want to keep the right to sue or continue to sue Google on your own about the claims in this Lawsuit, then you must take steps to get out of the Settlement Class. This is called excluding yourself—or it is sometimes referred to as “opting out.”`,
        "The Final Approval Hearing": `The Court will hold a hearing (called a Final Approval Hearing) to decide whether to approve the Settlement. You <strong>do not</strong> have to attend the hearing in order to get paid, although you may attend and ask to speak if you wish.`
    };

    sitePages.forEach((page) => {
        if (page.PageName !== "faqs") return;
        const content = page.PageContent;
        content.forEach((section) => {
            if (faqsLeads[section.SectionTitle]) {
                section.SectionLead = faqsLeads[section.SectionTitle];
            }
        });

        page.PageContent = content;
    });

    return sitePages;
}